
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    text: String,
  },
  data() {
    return {};
  },
  methods: {
    click() {
      this.$emit("action");
    },
  },
})
export default class HotspotLogoTips extends Vue {}
